import { useI18n } from '@change-corgi/core/react/i18n';

import { OG_IMAGE } from 'src/app/pages/about/main/shared/consts';

type Result = ModelHookResult<{
	title: string;
	description: string;
	image: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();

	const title = translate('fe.pages.about.title_tag');
	const description = translate('fe.pages.about.description_tag');

	return {
		data: {
			title,
			description,
			image: OG_IMAGE,
		},
	};
}
